import { relewiseFallback } from '@/shared/constants/constants';

export type RelewiseFailureReason = (typeof relewiseFallback.REASONS)[number];

export const isRelewiseFailureReason = (
  value: unknown
): value is RelewiseFailureReason =>
  relewiseFallback.REASONS.some((reason) => reason === value);
